export default function DeliveryIcon() {
  return <i className="fa-solid fa-truck"></i>
}